import React from 'react';
import OrgulloUPCarousel from './Slider/orgulloUp';
import axios from 'axios';

interface VAlumno{
    Nombre: string;
    Carrera: string;
    FechaEgreso: string;
    url_foto: string;
}

interface OrgulloSlide {
  nombre: string;
  carrera: string;
  anio: string;
  nombreEmpresa: string;
  descripcion: string;
  plantilla: string; // Imagen de fondo
  datosAlumno: VAlumno;
}

const API_URL = process.env.REACT_APP_API_URL;

const OrgulloUPWrapper: React.FC = () => {
    const [slides, setSlides] = React.useState<OrgulloSlide[]>([])

    const getInfo = async () => {
        try {
            const response = await axios.get(`${API_URL}/enlaces/getOrgullo`)
            const items = response.data;
            items.map((item: any, idx: number) => {
                console.log(item.datosAlumno.Nombre)
                console.log(item.datosAlumno.url_foto," ", item.datosAlumno.Nombre," ",item.datosAlumno.Carrera)
            })
            setSlides(items);
        } catch (error) {
            console.log('Error: ', error)
        }
    }

    React.useEffect(() => {
        getInfo();
    }, []);

    return (
        <OrgulloUPCarousel slides={slides} />
    )
}

export default OrgulloUPWrapper;
